// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"styles__bodyWrapper___6s1x-"};